module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-fabric straps-Ki-Lb.6c7369b8.png";